import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HintErrorComponent} from './components/hint-error/hint-error.component';
import {TooltipModule} from '@shared/modules/tooltip/tooltip.module';
import {HintInfoComponent} from './components/hint-info/hint-info.component';


@NgModule({
  declarations: [HintErrorComponent, HintInfoComponent],
  exports: [
    HintErrorComponent,
    HintInfoComponent
  ],
  imports: [
    CommonModule,
    TooltipModule
  ]
})
export class HintModule {
}
